import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemDetailsAnalysisTextStyled = styled(Text)`
  white-space: pre-wrap;
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  color: ${(props) => props.theme.colors.ai};
`
